
GP.GPMod('Chat.VChat', function(self) {
    var _conf, _data, _gui, _apis, _util, _events,
        _info, _log, _warn, _error, _timers, _vent, _cometD;

    this.on('before:start', function() {
        var chat_module   = self.app.module("Chat");
        chat_module.vchat = _vchat;
    });

    self.init_module = function() {
        var chat_module   = self.app.module("Chat");

        _conf   = chat_module.conf;
        _data   = chat_module.data;
        _apis   = chat_module.apis;
        _gui    = chat_module.gui;
        _util   = chat_module.util;
        _events = chat_module.events;

        _vent  = self.vent;
        _info  = self.app.Util.info;
        _log   = self.app.Util.log;
        _warn  = self.app.Util.warn;
        _error = self.app.Util.error;
        _trace = self.app.Util.trace;

        _log_obj      = self.app.Util.log_obj;
        _obj_snapshot = self.app.Util.obj_snapshot;

        _cometD = $.cometd;
        _timers = GP.Util.timers;

    };


    var _vchat = {
        // get's called on profile view, but only acts if we were waiting on a redirect to profile before
        // joining/starting a video chat room
        profile_init: function() {
            if (_data.profile_redirect_pending) {
                _data.profile_redirect_pending = false;

                _vchat.go_live();
            }

            // check for go_live=true url param, and "redirect" (in js, not page refresh) without url param
            if (_util.chk_go_live_param()) {
                // sometimes vent isn't redirecting properly without waiting a second or so
                setTimeout(function() {
                    _data.profile_redirect_pending = true;
                    GP.vent.trigger('Page:redirect', '/members/user/profile/');
                }, 1500);
            }
        },
        go_live_nav: function(json_data) {
            // var gender = GP.sdata.my_user.gender || 'MALE';

            // // redirect to videochat search unless woman/couple
            // if (_.contains(['WOMAN','COUPLE'], gender) !== true) {
            //     var qs_url = self.app.Util.clean_url('members/search/quicksearch', {
            //         search_type: 'livestreaming'
            //     });
            //     _vent.trigger('Page:redirect', qs_url);
            //     return;
            // }

            _vchat.go_live(json_data);
        },
        go_live: function(json_data) {
            // need to redirect to own profile page if we're not already there
            // init_js:user:profile event will be caught here and will continue
            if (_util.need_profile_redirect()) {
                _data.profile_redirect_pending = true;

                _vent.trigger('Page:redirect', self.app.Util.clean_url('members/user/profile'));
                return;
            }

            if (GP.sdata.my_user.unconverted_trial === true) {
                // _vent.trigger('Modal:open', {url: '/members/videochat/trial_user_notice/'});
                _vent.trigger('Page:redirect', self.app.Util.clean_url('members/billing/join', {trial: 1}));
                return;
            }

            if (GP.sdata.my_user.membership === 'PENDING_FREE') {
                // send pending free users to upgrade their CC
                _vent.trigger('Page:redirect', self.app.Util.clean_url('members/billing/update_cc'));
                return;
            }

            // force https if we're not already on https for whatever reason
            if (self.app.Util.test_https() === false) {
                var https_url = 'https:' + self.app.Util.clean_url('members/user/profile', {go_live: true});
                window.location.href = https_url;
                return;
            }


            _apis.send_action('create_room', {
                module:  _conf.vchat_ajax_module
            }, function(json) {

                if (json.hasOwnProperty('pub_url')) {
                    var duid = _data.duid || parseInt(GP.sdata.my_user.duid, 10) || null;

                    if (duid) {
                        _info('found pub_url: ', json.pub_url);
                        _conf.flussonic.source   = json.pub_url;
                        _conf.flussonic.restream = json.pub_url;

                        _vchat.join_room({
                            duid: duid,
                            role: 'publisher'
                        });
                    }
                } else if (json.hasOwnProperty('reason')) {
                    var alert_input = {template: json.reason};

                    if (json.hasOwnProperty('sprintf')) {
                        alert_input.sprintf = json.sprintf;
                    }
                    _vent.trigger('Modal:open:alert', alert_input);
                }
            });

            _vent.trigger('Header:hide_livestream_tooltip');

        },
        deny_private: function(json) {
            _apis.deny_private();
            _log('deny_private');
        },
        confirm_private: function(json) {
            // _apis.change_publisher_stream(_data.vc.room_id + 'priv', true);

            _vent.trigger('Modal:close');
            $('#stop-private-div').show();

            _gui.hide_private_sel();
            _apis.confirm_private();
        },
        set_cluster: function(json) {
            _log('VChat:set_cluster() called with json: ', json);

            if (json && json.cluster) {
                var server = parseInt(json.cluster, 10) || 0;

                // only update the wowza_cluster if we got a valid cluster (either 1 or 2 currently)
                if (server > 0) {
                    _data.vc.wowza_cluster = server;
                }
            }
        },
        join_room: function(json_data) {
            _warn('JOIN_ROOM json_data: ', json_data);
            _data.init();

            if (_tmp_vc_data) {
                json_data = $.extend(true, {}, _tmp_vc_data, json_data);
            }
           _log_obj('JOIN_ROOM json_data (_log_obj): ', json_data);

            if (typeof _cometD != 'undefined' && _cometD && _cometD.getStatus() == 'connected') {
                if (GP.sdata.my_user.unconverted_trial === true && GP.sdata.my_user.credits <= 0) {
                    // _vent.trigger('Modal:open', {url: '/members/videochat/trial_user_notice/'});
                    _vent.trigger('Page:redirect', self.app.Util.clean_url('members/billing/join', {trial: 1}));
                    return;
                }

                if (GP.sdata.my_user.membership === 'PENDING_FREE' && GP.sdata.my_user.credits <= 0) {
                    // send pending free users to upgrade their CC unless they have credits to use
                    _vent.trigger('Page:redirect', self.app.Util.clean_url('members/billing/update_cc'));
                    return;
                }


                // don't try to join a room/videochat if we're initializing
                if (_data.vc.initializing) {
                    return;
                }

                // no video streaming for safemode or bank compliance sites
                //var safe_mode = GP.sdata.my_user.pg;
                if (_bank_site) {
                    return;
                }

                _data.vc.initializing = true;

                // set flag indicating this chat session is a videochat
                _data.is_videochat = true;
                _data.vc.type = 'NORMAL';

                // change ajax_module we will send ajax requests to
                _data.ajax_module          = _conf.vchat_ajax_module;
                _data.vc.room_id           = parseInt(json_data.duid) || null; // previously wowza_duid
                _data.vc.username          = json_data.username;
                _data.vc.private_room      = json_data.private_room || false;
                _data.vc.ppm_cost          = parseInt(json_data.ppm_cost, 10) || 0;
                _data.vc.private_info.watcher_duid = json_data.private_duid || false; // aka watcher_duid

                if (json_data.type && _.contains(_conf.vc_room_types, json_data.type)) {
                    _data.vc.type = json_data.type;
                }

                // update mux env key for dev or if one is passed in to override default key
                if (json_data.mux_env_key) {
                    _data.mux_env_key = json_data.mux_env_key;
                }

                _info('JOIN_ROOM _data.vc: ', _data.vc);


                if (_data.vc.room_id && json_data.role) {
                    _events.setup_nanoscroll_vchat();

                    // hide the carousel for mobile before injecting the video chat template into the profile
                    if (_util.is_mobile()) {
                        _vent.trigger('ActivityCarousel:hide');
                    }

                    // hide the right drawer unless desktop-wide which should be have enough room to leave alone
                    if (MoshPit.get_size() != 'desktop-wide') {
                        GP.vent.trigger("RightDrawer:hide");
                    }

                    // show the video chat area at the to of the profile page
                    $('#profile-videochat-wrap').fadeIn();

                    // add our goal data if we've got it
                    if (json_data.hasOwnProperty('tip_goal')) {
                        _data.vc.tip_goal = json_data.tip_goal;
                    } else if (json_data.hasOwnProperty('goalTitle') && json_data.hasOwnProperty('goalCredits')) {
                        _data.vc.tip_goal = {
                            title:    json_data.goalTitle,
                            credits:  parseInt(json_data.goalCredits, 10),
                            progress: (parseInt(json_data.goalProgress, 10) || 0)
                        };
                    }

                    if (json_data.role == 'publisher') {
                        _data.vc.is_publisher = true;
                    }

                    // setup gui/vars/binds etc, and initialze
                    _gui.init_vchat();
                    _events.init_chat(_data.vc.room_id); // init chat room component of the videochat

                    if (_data.vc.private_room) {
                        _gui.show_private_notice();
                    } else if (_data.vc.ppm_cost > 0) {
                        _gui.show_private_btn();
                    }

                    if (_data.vc.is_publisher) {
                        _vchat.setup_publisher();
                    } else {
                        if (json_data.hasOwnProperty('urls')) {
                            _conf.flussonic.source   = json_data.urls.source;
                            _conf.flussonic.restream = json_data.urls.restream;

                            _vchat.setup_viewer();
                        }
                    }
                }
            } else {
                _log("vchat: cannot join room because not connected to push/cometD... setting up execute_on_handshake");

                // setup function to be executed once cometd handshake success event is triggered
                _data.execute_on_handshake = function() {
                    setTimeout(function() {
                        _vchat.join_room(json_data);
                    }, 1000);
                };
            }

            _info('_data at end of JOIN_ROOM: ', _obj_snapshot(_data));

        },
        setup_publisher: function(pub_url_param) {
            _log('setup_publisher called with pub_url_param: ', pub_url_param);

            // kill any existing publisher objects if needed
            _vchat.reset_publisher();

            var pub_url = _conf.flussonic.source;
            _log('SETUP PUBLISHER initial pub_url: ', pub_url);

            var $publisher = $('#flussonic-templates video.publisher').clone();
            // var $publisher = $('#flussonic-templates canvas.publisher').clone();
            $publisher.attr('id', _conf.vchat_publisher_id);

            $('#publisher-wrap').html($publisher);
            // $('#page').prepend($publisher);

            // ensure the video element (publisher object) uses the width of it's parent so it's sized correctly
            var $publisher_parent = $('#video-wrap'),
                publisher_ele     = document.getElementById(_conf.vchat_publisher_id),
                parent_width      = $publisher_parent.width();

            $(publisher_ele).width(parent_width).removeClass('hide');

            var private_token = null;

            if (pub_url_param) {
                _log('SETUP PUBLISHER pub_url_param found: ', pub_url_param);
                pub_url = pub_url_param;

            // use private url if it's a private/ppm show
            } else if (_data.vc.private_room && _data.vc.private_info.url) {
                _log('SETUP PUBLISHER private_room logic passed... _data.vc.private_info: ', _data.vc.private_info);

                [pub_url, private_token] = _util.parse_private_url(_data.vc.private_info.url);

                _data.vc.switch_url = null;
            }

            _log('SETUP PUBLISHER pub_url after private_info check: ', pub_url);
            _log('SETUP PUBLISHER private_token after private_info check: ', private_token);

            // GTFO if no pub_url is available for use
            if (!pub_url) {
                _warn('SETUP PUBLISHER pub_url check failed... returning');
                return false;
            }

            let pub_options =  {
                preview: document.getElementById(_conf.vchat_publisher_id),
                whipwhap: true,
                constraints: {
                    audio: true,
                    video: true
                    // video: _conf.video_constraints
                },
                statsSendEnable: true,
                // statsSendTime: 60,
                onEvent: function (event) {
                    /*
                        { type: 'started', started_at: #Date# } - runs when the streaming is started.
                        { type: 'closed', closed_at: #Date# }   - runs when the streaming is closed.

                        {type: 'connection state', connection: 'connected' } - runs when connection state changes
                        opened - when connection is opened
                        connected - when ICE candidates is connected
                        closed - when user performed connection close
                        disconnected - when server side closed ICE candidates connection
                    */

                    _log('PUBLISHER onEvent called, event: ', event);

                    // hide the connection status overlay after connection state changes to connected
                    if (event.type === 'connection state') {
                        if (event.connection === 'connected') {
                            setTimeout(() => _gui.hide_connection_status(), 1000);
                        } else {
                            _gui.show_connection_status();
                        }
                    }
                }
            };

            if (private_token) {
                pub_options.authTokenName = 'token';
                pub_options.tokenValue = private_token;
            }
            _log('vchat.setup_publisher pub_url before new Publisher: ', pub_url);
            _log('vchat.setup_publisher pub_options before new Publisher: ', pub_options);


            // setup flussonic webRTC Publisher object to setup stream to flussonic server
            _data.flussonic.pub_obj = new Publisher(
                pub_url,     // The URL to a Flussonic stream that has a published source
                pub_options, // options for configuring publisher object
                _conf.publisher_debug // Log to console the Publisher's internal debug messages?
            );
            _data.flussonic.pub_obj.on(PUBLISHER_EVENTS.STREAMING, function() {
                _info('Streaming started');

                // show connection status overlay until connection is established
                _gui.show_connection_status();

                publisher_ele.removeAttribute('controls');
                _gui.show_mic_btn();

                _data.vc.is_publisher = true;
                _data.vc.initializing = false;

                _util.start_videochat_publisher_timer();
                _gui.vchat_started_profile();
                _gui.update_mic_btn('on');

                _vchat.update_devices_in_use();

                // call videochat.mod_live with start_ppm action if we haven't already
                if (_data.vc.private_room && !_data.vc.private_info.start_ppm_called) {
                    _gui.hide_ticket_btn();

                    _log('WAITING 1 SECOND TO CALL START_PPM');
                    setTimeout(function() {
                        _apis.start_ppm();
                    }, 1000);
                }
            });

            let start_opts = {
                openPeerConnectionOptions: {
                    onGetUserMediaError: (error) => {
                        _error('onGetUserMediaError: ', error);
                    }
                }
            };
            _data.flussonic.pub_obj.start(start_opts);
            // _data.flussonic.pub_obj.start();

            // trigger modal for setting a tip goal
            if (!_data.vc.private_room) {
                _apis.get_goal_modal();
            }
        },
        update_available_cameras: () => {
            _vchat.get_input_devices().then(devices => {
                _log('vchat.update_available_cameras devices: ', devices);
                _data.flussonic.pub_inputs = devices;

                if (devices.video.length > 1) {
                    _gui.show_cam_select(devices.video);
                }
            }).catch((error) => {
                _error("Error getting input devices:", error);
            });
        },
        get_input_devices: async () => {
            if (!navigator?.mediaDevices?.enumerateDevices) {
                _error("enumerateDevices() not supported.");
                return [];
            }

            try {
                // get a list of available cameras and mics
                const devices = await navigator.mediaDevices.enumerateDevices();

                const video_inputs = devices.filter((device) => device.kind === "videoinput");
                const audio_inputs = devices.filter((device) => device.kind === "audioinput");

                return {
                    video: video_inputs,
                    audio: audio_inputs
                };
            } catch (error) {
                _error("_vchat.get_input_devices() exception occurred: ", error);
                return {};
            }
        },
        change_camera: function(device_id) {
            if (device_id) {
                _vchat.get_media_stream_track_for_device(device_id).then(video_track => {
                    if (video_track) {
                        _log('...change_camera... Got MediaStreamTrack:', video_track);

                        // create a new MediaStream with the selected video track from the new camera
                        const new_stream = new MediaStream([video_track]);

                        // update the publisher preview video element source with the new stream
                        const video_element = document.getElementById(_conf.vchat_publisher_id);
                        if (video_element) {
                            video_element.srcObject = new_stream;
                            video_element.play();
                        }

                        // switch the publishing track in the flussonic publisher object
                        // to start publishing video from the new device/camera
                        _data.flussonic.pub_obj.switchTrack(video_track);

                        // update our state with new camera device id
                        _data.flussonic.active_devices.video = device_id;

                        _vchat.update_available_cameras();

                    } else {
                        _error('Failed to get MediaStreamTrack.');
                    }
                });
            }
        },
        get_media_stream_track_for_device: async function(device_id) {
            const constraints = {
                video: {
                    deviceId: { exact: device_id }
                }
            };

            try {
                const stream = await navigator.mediaDevices.getUserMedia(constraints);
                const video_track = stream.getVideoTracks()[0];
                return video_track;
            } catch (error) {
                _error('Error accessing media devices.', error);
                return null;
            }
        },
        update_devices_in_use: function() {
            _log('vchat.update_devices_in_use called... _data.flussonic.active_devices: ', _data.flussonic.active_devices);
            if (!navigator?.mediaDevices?.getUserMedia) {
                _error("getUserMedia() not supported.");
                return [];
            }

            // get the deviceId for webcam in use
            navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
                // Get the video track from the MediaStream
                const videoTrack = stream.getVideoTracks()[0];

                // Get the settings of the video track
                const settings = videoTrack.getSettings();

                // Log or use the deviceId of the webcam
                _info('Current webcam deviceId:', settings.deviceId);

                _data.flussonic.active_devices.video = settings.deviceId;
                _vchat.update_available_cameras();

            })
            .catch(error => {
                _warn('Error accessing the webcam:', error);
            });

            // get the deviceId for microphone in use
            navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
                // Get the audio track from the MediaStream
                const audioTrack = stream.getAudioTracks()[0];

                // Get the settings of the audio track
                const settings = audioTrack.getSettings();

                // Log or use the deviceId of the microphone
                _info('Current microphone deviceId:', settings.deviceId);

                _data.flussonic.active_devices.audio = settings.deviceId;

            })
            .catch(error => {
                _warn('Error accessing the microphone:', error);
            });
        },
        // setup the webRTC viewer for watching the user's stream
        setup_viewer: function(access_checked, ticket_show) {
            _log_obj('vchat.setup_viewer called. _LOG_OBJ(_data): ', _data);
            _log('vchat.setup_viewer, access_checked param: ', access_checked);
            _log('vchat.setup_viewer, ticket_show param: ', ticket_show);

            // Needed for when calling setup_viewer to switch streams
            _vchat.reset_reconnect_timers();

            var access_granted    = false,
                setup_ticket_show = false,
                private_token     = null;

            var player_url = _conf.flussonic.restream;
            _log('vchat.setup_viewer initial player_url: ', player_url);

            if (_data.vc.private_room && _data.vc.private_info.url) {
                _log('vchat.setup_viewer private_room logic passed... _data.vc.private_info: ', _data.vc.private_info);

                [player_url, private_token] = _util.parse_private_url(_data.vc.private_info.url);

                _data.vc.switch_url = null;

            } else if (_data.vc.switch_url) {
                _log('vchat.setup_viewer switch_url logic passed... setting player_url to: ', _data.vc.switch_url);

                player_url = _data.vc.switch_url;
                _data.vc.switch_url = null;
            }
            _log('vchat.setup_viewer player_url after checking private/switch urls: ', player_url);

            // call the check_videochat_access api if we haven't checked yet
            if (!access_checked) {
                _log('vchat.setup_viewer checking if access is allowed. access_checked param: ', access_checked);

                _apis.check_videochat_access(_vchat.setup_viewer, this);
                return;
            } else if (access_checked && !ticket_show) {
                access_granted = true;
            } else if (access_checked && ticket_show) {
                setup_ticket_show = true;

                if (_data.vc.ticket_info.ticket_paid) {
                    _log('ticket show paid for.  allow access');
                    access_granted = true;
                } else if (!_data.vc.ticket_info.ticket_paid && !_data.vc.ticket_info.ticket_started) {
                    // ticket show is counting down, so we're ok to setup player/viewer
                    _log('ticket show has not started yet, allow');
                    access_granted = true;
                }
            }

            if (_data.vc.private_room && _data.duid != _data.vc.private_info.watcher_duid) {
                _log('vchat.setup_viewer private room ACCESS DENIED (not the watcher)... setting access_granted to false');
                access_granted = false;
            }

            // init the ticket show gui elements if we needed
            if (setup_ticket_show) {
                _gui.init_ticket_info();
            }

            if (!access_granted) {
                _log('vchat.setup_viewer, access_granted FALSE, abort viewer setup');
                return;
            }

            _log('vchat.setup_viewer, ACCESS GRANTED');

            _vchat.reset_player();
            _gui.show_loading_notice();


            var $player = $('#flussonic-templates video.player').clone();
            $player.attr('id', _conf.vchat_player_id);
            $('#' + _conf.vchat_player_wrap).html($player);

            var $player_parent = $('#video-wrap'),
                vid_width      = $player_parent.width(),
                player_options = {
                  // sentryConfig: _conf.flussonic.sentry
                  // autoplay: true,
                  whipwhap: true,
                  retryMax: 10,
                  retryDelay: 1000,
            };

            // player_options = {
            //     //   autoplay: true,
            //       whipwhap: true,
            // };

            var video_player = document.getElementById(_conf.vchat_player_id);
            $(video_player).width(vid_width).removeClass('hide');


            if (private_token) {
                player_options.authTokenName = 'token';
                player_options.tokenValue = private_token;
            }
            _log('vchat.setup_viewer player_url before new Player: ', player_url);
            _log('vchat.setup_viewer player_options before new Player: ', player_options);

            // setup our webRTC player object
            _data.flussonic.player_obj = new Player(
                video_player,
                player_url,
                player_options,
                _conf.player_debug
            );

            _data.flussonic.player_obj.on(PLAYER_EVENTS.PLAY, function (msg) {
                _log('!!!!!!!!PLAYER EVENT PLAY, msg: ', msg);

                // reset _data.vc.initializing var and reset timers
                _data.vc.initializing = false;
                _vchat.reset_reconnect_timers(true);

                // update gui once stream has started playing
                _gui.hide_loading_notice();
                _gui.vchat_started_profile();

                // hide private notice/overlay and show/hide buttons
                if (_data.vc.private_room) {
                    _gui.private_started();
                }

                // attempt to unmute and set volume after play event has triggered
                setTimeout(function() {
                    _log('PLAYER CHECKING TO SEE IF WE CAN UPDATE AUDIO');

                    // only try to unmute and add volume if user has interacted with the site
                    // otherwise video will pause automatically
                    if (_gp_user_interacted) {
                        _log('_gp_user_interacted chk passed... REMOVING MUTED ATTR AND SETTING VOLUME');
                        video_player.muted  = false;
                    } else {
                        _log('_gp_user_interacted chk FAILED');

                        // add a button/overlay to manually unmute/set volume?
                    }

                }, 1000);

            });
            _data.flussonic.player_obj.on(PLAYER_EVENTS.DEBUG, function (msg) {
                _log('PLAYER EVENT DEBUG handler called. msg: ', msg);
            });
            _data.flussonic.player_obj.on(PLAYER_EVENTS.FAIL, function (msg) {
                _log('!!!!!!!!!PLAYER EVENT FAIL handler called. msg: ', msg);
                _log('!!!!!!!!!PLAYER EVENT FAIL _data: ', _obj_snapshot(_data));

                // show loading notice on fail. loading notice will be removed on successful play event callback
                _gui.show_loading_notice();

                // swap source url for the player if we have one and start the new stream
                if (_data.vc.switch_url) {
                    _data.flussonic.player_obj.url = _data.vc.switch_url;
                    _data.vc.switch_url = null;

                    _vchat.start_player();

                } else if (_data.vc.initializing === false && _data.vc.retry_count < 5) {
                    _data.vc.initializing = true;
                    _data.vc.retry_count++;

                    _vchat.start_player();

                } else if (_data.vc.retry_count < 5) {
                    _log('!!!!!!!!!PLAYER EVENT FAIL rety_count: ', _data.vc.retry_count);

                    _data.vc.initializing = true;
                    _data.vc.retry_count++;

                    // setup timeout to setup fresh viewer
                    setTimeout(function() {
                        _info('setTimeout calling setup_viewer from player fail event handler');

                        _vchat.setup_viewer(true);
                    }, 1000);

                    // kill our current video player
                    _vchat.reset_player();
                }

            });

            // start the video player
            _vchat.start_player();
        },
        // changed from tip_received to update_goal_progress
        update_goal_progress: function(json) {
            _log('videochat update_goal_progress: ', json);

            // check if this videochat session has a tip goal set
            if (!$.isEmptyObject(_data.vc.tip_goal)) {
                if (json && json.tip_amount) {
                    var add_to_progress = parseInt(json.tip_amount, 10) || 0;

                    if (add_to_progress) {
                        _data.vc.tip_goal.progress += add_to_progress;

                        // update UI when tip is received toward goal
                        _gui.videochat_goal_updated();
                    }
                }
            }
        },
        update_tip_goal: function(json) {
            _log('videochat update_tip_goal: ', json);

            // check if this videochat session has a tip goal set
            if (json && json.hasOwnProperty('tip_goal')) {
                var goal = json.tip_goal;

                // update title and credits for reaching goal if it's new or not
                _data.vc.tip_goal.title   = goal.title;
                _data.vc.tip_goal.credits = parseInt(goal.credits, 10);

                // only reset progress if it's a new goal
                if (json.new_goal) {
                    _data.vc.tip_goal.progress = 0;
                } else if (json.updated_goal) {
                    _data.vc.tip_goal.progress = parseInt(goal.progress, 10);
                }

                // update UI when goal is added/updated
                _gui.videochat_goal_updated();
            }
        },
        setup_tip_sound: function(mp3_file) {

            var tip_sound = document.createElement('audio');
            tip_sound.src = mp3_file || _conf.vchat_tip_sound;

            _data.vc.tip_sound = tip_sound;
        },
        play_tip_sound: function() {
            if (_data.vc.tip_sound && _data.vc.play_tip_sound) {
                _data.vc.tip_sound.volume = 0.5;
                _data.vc.tip_sound.play();
            }
        },
        play_loud_tip_sound: function() {
            if (_data.vc.tip_sound && _data.vc.play_tip_sound) {
                _data.vc.tip_sound.volume = 1;
                _data.vc.tip_sound.play();
            }
        },
        clear_history: function() {
            _log('vchat.clear_history');

            _apis.send_action('clear_history', {
                module:  _conf.vchat_ajax_module,
                room_id: _data.vc.room_id
            }, function(json) {
                _log('vchat.clear_history cb. json: ', json);

                if (json && json.success) {
                    _log('vchat.clear_history cb calling _gui.clear_chat_history()');

                    _gui.clear_chat_history();
                }
            });
        },
        toggle_mic: function(e) {
            _log('vchat.toggle_mic called with e: ', e);
            _log('vchat.toggle_mic pub_obj: ', _data.flussonic.pub_obj);

            var $btn = $(e.currentTarget);
            _log('vchat.toggle_mic $btn: ', $btn);

            if (_data.flussonic.pub_obj) {
                var mic_status = _data.flussonic.pub_obj.stream.getAudioTracks()[0].enabled;
                // call publisher obj mute method to toggle mic on/off
                _data.flussonic.pub_obj.mute();

                // if mic is on, then toggle off, otherwise toggle on
                // update gui to reflect current microphone state
                if (mic_status) {
                    // disable the publisher object mediaStream's audio track
                    // _data.flussonic.pub_obj.stream.getAudioTracks()[0].enabled = false;

                    _gui.update_mic_btn('off');

                } else {
                    // enable the publisher object mediaStream's audio track
                    // _data.flussonic.pub_obj.stream.getAudioTracks()[0].enabled = true;

                    _gui.update_mic_btn('on');
                }
            }
        },
        // stop publishing/viewing videochat stream
        abort: function() {
            _trace('VChat.abort called _data: ', _obj_snapshot(_data));

            if (_data.vc.bypass_vjs_close === false) {
                _events.cleanup();
                _gui.reset_vchat();

                // cleanup cometd chat room if user doing the streaming cancels/aborts
                if (_data.vc.is_publisher) {
                    _apis.send_action('remove_room', {
                        room_id: _data.vc.room_id,
                        module:  _conf.vchat_ajax_module
                    });
                }
            }
        },
        reset_publisher: function() {
            _trace('VChat.reset_publisher called... _data:', _obj_snapshot(_data));

            // kill any existing publisher objects if needed
            if (_data.flussonic.pub_obj) {
                _timers.clear(_conf.timer_cps);

                if (_data.flussonic.pub_obj.stop) {
                    _data.flussonic.pub_obj.stop();
                }
                _data.flussonic.pub_obj = null;
            }
            // remove all child nodes from the #publisher-wrap div for the video player/element
            $(_conf.vchat_publisher_wrap).empty();
        },
        reset_player: function() {
            _trace('VChat.reset_player called... _data:', _obj_snapshot(_data));

            _vchat.reset_publisher();

            // stop and destroy the flussonic webRTC Player object if it exists
            if (_data.flussonic.player_obj) {
                _info('VChat.reset_player calling player_obj.destroy');
                _timers.clear(_conf.timer_check_stream);

                if (_data.flussonic.player_obj.destroy) {
                    _data.flussonic.player_obj.destroy();
                }
                _data.flussonic.player_obj = null;
            }

            // remove all child nodes from the #player-wrap div for the video player/element
            $(_conf.vchat_player_wrap).empty();
        },
        start_player: function() {
            _trace('VChat.start_player called from:');
            _data.vc.initializing = true;

            // make sure we've only got one health check timer going on, so clear any previous timers first
            _timers.clear(_conf.timer_check_stream);

            _gui.show_loading_notice();

            if (_data.flussonic.player_obj) {
                _data.flussonic.player_obj.play();

                _timers.set(_vchat.check_stream, 10000, _conf.timer_check_stream, true);
            }
        },
        check_stream: function() {
            // stop and restart video player if we're not connected
            if (!_vchat.is_stream_active()) {
                _warn('check_stream logic failed for is_stream_active');

                _data.flussonic.player_obj.stop();
                _vchat.start_player();

            } else {
                _vchat.reset_reconnect_timers(true);
            }
        },
        switch_publisher_source: function(new_url) {
            _trace('vchat.switch_publisher_source called with new_url: ', new_url);

            // clear the publisher health check timer before stopping.  it will get setup again in play event
            _timers.clear(_conf.timer_cps);
            _vchat.setup_publisher(new_url);

            // trigger the publisher's stop method and update the source url in player's onWebsocketClose event
            // _data.vc.switch_url = new_url;
            // _data.flussonic.pub_obj.stop();
        },
        switch_player_source: function(new_url) {
            _trace('vchat.switch_player_source called with new_url: ', new_url);

            _gui.show_loading_notice();
            _data.vc.switch_url = new_url;

            _vchat.setup_viewer();
        },
        // reset videochat _data properties back to normal
        reset_private: function() {
            _data.vc.type = 'NORMAL';
            _data.vc.private_room = false;

            _data.vc.private_info.url              = null;
            _data.vc.private_info.watcher_duid     = null;
            _data.vc.private_info.private_paid     = false;
            _data.vc.private_info.start_ppm_called = false;

            _gui.private_stopped();
        },
        reset_reconnect_timers: function(hide_loading_notice) {
            _timers.clear(_conf.timer_vr);

            // need to make sure to clear timer out if exists,
            // otherwise the ref to the previous timer can never be recovered and cleared
            if (_data.vc.reconnecting_interval) {
                clearInterval(_data.vc.reconnecting_interval);
                _data.vc.reconnecting_interval = null;
            }

            // call _gui.hide_loading_notice() via optional function param
            if (typeof hide_loading_notice != 'undefined' && hide_loading_notice === true) {
                _gui.hide_loading_notice();
            }
        },
        is_publisher_active: function() {
            var pub           = _data.flussonic.pub_obj,
                rtc_connected = false,
                has_video     = false;


            // check RTCPeerConnection's connection state
            if (pub && pub.peerConnection && pub.peerConnection.iceConnectionState) {
                if (pub.peerConnection.iceConnectionState == 'connected') {
                    rtc_connected = true;
                }
            }

            if (pub && pub.stream) {
                has_video = pub.stream.getVideoTracks().length ? true : false;
            }

            // if (rtc_connected && has_video) {
            if (has_video) {
                _info('is_publisher_active has_video is TRUE... stream is active');
                return true;
            }

            _info('is_publisher_active returning FALSE... rtc_connected: ', rtc_connected, ' has_video: ', has_video);
            return false;
        },
        // check if the webRTC MediaStream is active and currently playing
        is_stream_active: function() {
            // don't need to check if player is playing if user is the one publishing/streaming
            if (!_data.vc.is_publisher) {

                var player        = _data.flussonic.player_obj,
                    rtc_connected = false,
                    has_video     = false;

                // check RTCPeerConnection's connection state
                if (player?.remotePc?.iceConnectionState) {
                    rtc_connected = (player.remotePc.iceConnectionState == 'connected');
                    _info('is_stream_active, rtc_connected: ', rtc_connected);

                    // get all info about the RTCPeerConnection
                    if (_data.debug_rtc_peer_stats) {
                        player.remotePc.getStats(null).then(stats => {
                            _info('stats returned from getStats: ', stats);

                            // iterate over the RTCStatsReport object (stats)
                            stats.forEach(report => {
                                _info('getStats report: ', report);
                            });
                        });
                    }
                }

                // check MediaStreamTrack for video
                if (player?.remoteVideo?.srcObject) {
                    has_video = player.remoteVideo.srcObject.getVideoTracks().length ? true : false;
                    _info('is_stream_active, has_video: ', has_video);
                }

                if (rtc_connected && has_video) {
                    _info('is_stream_active has_video and rtc_connected are TRUE... stream is active');
                    return true;
                }
            }

            _log('is_stream_active returning FALSE');
            return false;
        },
        // handle state changes such as the user streaming stops publishing or starts publishing again
        handle_state_change: function(json) {
            _log('videochat handle_state_change: ', json);

            if (json.room_id == _data.duid) {
                if (json.event == 'publish') {
                    _gui.show_ticket_btn();
                    if (_data.vc.private_room !== true) {
                        _gui.show_private_sel();
                        _gui.show_ticket_btn();
                        $('#stop-private-div').hide();
                    } else {
                        if (_data.duid == _data.vc.room_id) {
                            $('#stop-private-div').show();
                            _gui.hide_ticket_btn();
                        }
                    }

                    // hide the connection status overlay after 1 second
                    setTimeout(() => _gui.hide_connection_status(), 1000);

                } else if (json.event == 'unpublish') {
                    _gui.hide_ticket_btn();
                    _gui.hide_private_sel();
                    $('#stop-private-div').hide();
                }
                _log('handle_state_change returning because it is our room');

                return;
            }

            // take action on an event if present
            if (json && json.event) {

                switch (json.event) {
                    case 'publish':
                        _log('HANDLE STATE CHANGE PUBLISH EVENT RECEIVED.  json: ', json);
                        _vchat.reset_reconnect_timers(true);

                        // start the video stream if we're not already watching it
                        if (_data.vc.type == 'NORMAL') {
                            if (!_vchat.is_stream_active()) {
                                _vchat.start_player();
                            }
                        }

                        break;

                    case 'unpublish':
                        _vchat.reset_reconnect_timers();

                        var counter = (_conf.vc_reconnecting_timer / 1000),
                            title   = (GP.Util.check_nested((js_lang || {}), 'videochat.reconnecting.title')
                                         ? js_lang.videochat.reconnecting.title
                                         : 'Stream interrupted...'
                                      ),
                            msg     = (GP.Util.check_nested((js_lang || {}), 'videochat.reconnecting.msg')
                                         ? js_lang.videochat.reconnecting.msg
                                         : 'Attempting to reconnect to stream'
                                      );

                        _data.vc.reconnecting_interval = setInterval(function() {
                            _gui.show_loading_notice(title, msg + '(' + --counter + ')');
                        }, 1000);

                        _timers.set(function() {
                            _vchat.reset_reconnect_timers();
                            _vchat.abort();

                            $('.btn-videochat-profile').hide();
                        }, _conf.vc_reconnecting_timer, _conf.timer_vr, true);

                        break;

                    case 'room_type_change':
                        _log('VIDEOCHAT ROOM_TYPE_CHANGE: ', json.room_type);

                        if (json.room_type && _.contains(_conf.vc_room_types, json.room_type)) {
                            _data.vc.type = json.room_type;
                        }

                        if (_data.vc.type == 'PPM') {
                            if (_data.duid != _data.vc.private_info.watcher_duid) {
                                _vchat.reset_reconnect_timers(true);
                                _gui.show_private_notice();
                                _vchat.reset_player();
                            }
                        }

                        break;
                }
            }

            // update state if it's present
            if (json && json.state) {
                _data.vc.state = json.state;
            }
        }
    };

});

